module.exports = __webpack_public_path__ + "static/media/ic_file.bf09b700.svg";